import useProtoMethod from "./useProtoMethod";
import {
  GetOrCreateSessionRequest,
  GetOrCreateSessionResponse,
  GetSubmissionRequest,
  GetSubmissionResponse,
  ListSubmissionsRequest,
  ListSubmissionsResponse,
  RespondToAssignmentRequest,
  RespondToAssignmentResponse,
  SendAssignmentOpportunitiesRequest,
  SendAssignmentOpportunitiesResponse,
  SignupSubmissionRequest,
  SignupSubmissionResponse,
  UpdateSessionRequest,
  UpdateSessionResponse,
  UpdateSubmissionRequest,
  UpdateSubmissionResponse,
  GetSignupPaymentLinkRequest,
  GetSignupPaymentLinkResponse,
  ListAssignmentCandidatesResponse,
  ListAssignmentCandidatesRequest,
  ExtendAssignmentExpirationRequest,
  ExtendAssignmentExpirationResponse,
} from "../protogen/signup_service_pb";

const useGetOrCreateSession = (
  callback?: (r: GetOrCreateSessionResponse) => void,
) => {
  return useProtoMethod<GetOrCreateSessionRequest, GetOrCreateSessionResponse>(
    "GetOrCreateSession",
    GetOrCreateSessionResponse,
    { callback },
  );
};

const useUpdateSession = (callback?: (r: UpdateSessionResponse) => void) => {
  return useProtoMethod<UpdateSessionRequest, UpdateSessionResponse>(
    "UpdateSession",
    UpdateSessionResponse,
    { callback },
  );
};

const useSignupSubmission = (
  callback?: (r: SignupSubmissionResponse) => void,
) => {
  return useProtoMethod<SignupSubmissionRequest, SignupSubmissionResponse>(
    "SignupSubmission",
    SignupSubmissionResponse,
    { callback },
  );
};

const useListSubmissions = (
  callback?: (r: ListSubmissionsResponse) => void,
) => {
  return useProtoMethod<ListSubmissionsRequest, ListSubmissionsResponse>(
    "ListSubmissions",
    ListSubmissionsResponse,
    { callback },
  );
};

const useGetSubmission = (callback?: (r: GetSubmissionResponse) => void) => {
  return useProtoMethod<GetSubmissionRequest, GetSubmissionResponse>(
    "GetSubmission",
    GetSubmissionResponse,
    { callback },
  );
};

const useUpdateSubmission = (
  callback?: (r: UpdateSubmissionResponse) => void,
) => {
  return useProtoMethod<UpdateSubmissionRequest, UpdateSubmissionResponse>(
    "UpdateSubmission",
    UpdateSubmissionResponse,
    { callback },
  );
};

const useGetSignupPaymentLink = (
  callback?: (r: GetSignupPaymentLinkResponse) => void,
) => {
  return useProtoMethod<
    GetSignupPaymentLinkRequest,
    GetSignupPaymentLinkResponse
  >("GetSignupPaymentLink", GetSignupPaymentLinkResponse, { callback });
};

const useSendAssignmentOpportunities = (
  callback?: (r: SendAssignmentOpportunitiesResponse) => void,
) => {
  return useProtoMethod<
    SendAssignmentOpportunitiesRequest,
    SendAssignmentOpportunitiesResponse
  >("SendAssignmentOpportunities", SendAssignmentOpportunitiesResponse, {
    callback,
  });
};

const useRespondToAssignment = (
  callback?: (r: RespondToAssignmentResponse) => void,
) => {
  return useProtoMethod<
    RespondToAssignmentRequest,
    RespondToAssignmentResponse
  >("RespondToAssignment", RespondToAssignmentResponse, { callback });
};

const useListAssignmentCandidates = (
  callback?: (r: ListAssignmentCandidatesResponse) => void,
) => {
  return useProtoMethod<
    ListAssignmentCandidatesRequest,
    ListAssignmentCandidatesResponse
  >("ListAssignmentCandidates", ListAssignmentCandidatesResponse, { callback });
};

const useExtendAssignmentExpiration = (
  callback?: (r: ExtendAssignmentExpirationResponse) => void,
) => {
  return useProtoMethod<
    ExtendAssignmentExpirationRequest,
    ExtendAssignmentExpirationResponse
  >("ExtendAssignmentExpiration", ExtendAssignmentExpirationResponse, {
    callback,
  });
};

export {
  useGetOrCreateSession,
  useUpdateSession,
  useSignupSubmission,
  useListSubmissions,
  useUpdateSubmission,
  useGetSignupPaymentLink,
  useGetSubmission,
  useSendAssignmentOpportunities,
  useRespondToAssignment,
  useListAssignmentCandidates,
  useExtendAssignmentExpiration,
};
